import React from 'react';
import PaymentAccount from './payment_account';
import PaymentCard from './payment_card';
import PaymentPayPalButton from './payment_paypal_button';
import CEFMessage from '../cef_message/cef_message';
import warningIconRed from '../../../assets/images/shared/icons/warning-red.png';
import InfoGreySVG from '../../../assets/images/shared/icons/info-grey.svg';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payment_method:
        this.props.signed_in === true
          ? this.props.cashOnly === true
            ? 'CARD'
            : 'ACCOUNT'
          : 'CARD',
      telephone: '',
    };
    this.handlePaymentMethodChange = this.handlePaymentMethodChange.bind(this);
    this.showDetailErrors = this.showDetailErrors.bind(this);
  }

  showDetailErrors(show_display_error, display_errors) {
    this.props.showDetailErrors(show_display_error, display_errors);
  }
  handlePaymentMethodChange(method) {
    this.props.showDetailErrors(false, []);

    if (this.props.processingState !== true) {
      if (this.props.signed_in === false && method === 'ACCOUNT') {
        this.setState({
          payment_method: 'CARD',
        });
      } else {
        this.setState({
          payment_method: method,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.paymentOpen !== this.props.paymentOpen) {
      if (this.props.signed_in === false) {
        this.handlePaymentMethodChange('CARD');
      } else {
        const paymentMethod = this.props.cashOnly === true ? 'CARD' : 'ACCOUNT';
        this.handlePaymentMethodChange(paymentMethod);
      }
    }
  }

  render() {
    const {
      orderApprovalsEnabled,
      summary,
      paymentOptions: {
        account: accountPaymentsEnabled,
        its: itsEnabled,
        paypal: paypalEnabled,
      },
      message,
    } = this.props || '';

    const {
      payment_details: {
        order_approval_payment_message: orderApprovalPaymentMessage,
      },
    } = summary;

    const showOrderApprovalMessage = orderApprovalPaymentMessage && (
      <div className="order-approval-required-message m-top-1rem">
        <img
          src={InfoGreySVG}
          alt=""
          className="mr-025"
          width="16"
          height="16"
        />
        <span>{orderApprovalPaymentMessage}</span>
      </div>
    );

    let paymentPanel = '';

    switch (this.state.payment_method) {
      case 'ACCOUNT':
        {
          accountPaymentsEnabled &&
            (paymentPanel = (
              <PaymentAccount
                paymentTotal={this.props.paymentTotal}
                completeAccountOrderUrl={this.props.completeAccountOrderUrl}
                completeOrder={this.props.completeOrder}
                setPaymentStatus={this.props.setPaymentStatus}
                showDetailErrors={this.showDetailErrors}
                showPaymentDisplayError={this.props.show_display_error}
                paymentDisplayErrors={this.props.display_errors}
                orderApprovalPaymentMessage={orderApprovalPaymentMessage}
              />
            ));
        }
        break;
      case 'CARD':
        {
          itsEnabled &&
            (paymentPanel = (
              <PaymentCard
                current_step={this.props.current_step}
                delivery_address={this.props.delivery_address}
                setInvoiceAddress={this.props.setInvoiceAddress}
                addresses={this.props.addressBook}
                addressMode={this.props.addressMode}
                setAddressFromAddressBook={this.props.setAddressFromAddressBook}
                setInvoiceAddressFromAddressBook={
                  this.props.setInvoiceAddressFromAddressBook
                }
                invoice_address={this.props.invoice_address}
                customerInvoiceAddress={this.props.customerInvoiceAddress}
                addressEnquiryUrl={this.props.addressEnquiryUrl}
                deliveryAddressUrl={this.props.deliveryAddressUrl}
                billingAddressUrl={this.props.billingAddressUrl}
                getAddressBook={this.props.getAddressBook}
                setAddressMode={this.props.setAddressMode}
                signed_in={this.props.signed_in}
                completeOrder={this.props.completeOrder}
                itsPaymentUrl={this.props.itsPaymentUrl}
                paymentTotal={this.props.paymentTotal}
                assets={this.props.assets}
                setPaymentStatus={this.props.setPaymentStatus}
                configGenericError={this.props.configGenericError}
                genericErrorConfig={this.props.genericErrorConfig}
                name={this.props.name}
                showDetailErrors={this.showDetailErrors}
                show_payment_display_error={this.props.show_display_error}
                payment_display_errors={this.props.display_errors}
                branchAddressFlag={this.props.branchAddressFlag}
                toggleGenericError={this.props.toggleGenericError}
              />
            ));
        }
        break;
      case 'PAYPAL':
        {
          paypalEnabled &&
            (paymentPanel = (
              <PaymentPayPalButton
                completeOrder={this.props.completeOrder}
                paypalPaymentUrl={this.props.paypalPaymentUrl}
                paymentTotal={this.props.paymentTotal}
                setPaymentStatus={this.props.setPaymentStatus}
                assets={this.props.assets}
                name={this.props.name}
                email={this.props.email}
                showDetailErrors={this.showDetailErrors}
                show_payment_display_error={this.props.show_display_error}
                payment_display_errors={this.props.display_errors}
                configGenericError={this.props.configGenericError}
                genericErrorConfig={this.props.genericErrorConfig}
                toggleGenericError={this.props.toggleGenericError}
              />
            ));
        }
        break;
    }

    return (
      <div
        className={
          'checkout-panel payment-step payment-details-step ' +
          (this.props.current_step !== 'PAYMENT' ? 'not-active' : '')
        }>
        <div className="checkout-header-title">
          <div className="checkout-header-title-left">
            <strong>{this.props.step}.</strong> Payment
          </div>
        </div>

        <div className="checkout-sub-panel payment">
          <div
            className={
              ' ' +
              (this.props.processingState === true ? ' disable-panel' : '')
            }>
            <h2>
              Payment Details{' '}
              <img src={this.props.assets.misc.secure} className="pull-right" />
            </h2>

            {message.global && (
              <CEFMessage
                icon={warningIconRed}
                text={message.global}
                classNames={'cef-message--danger'}
              />
            )}

            <p>
              <strong>Please select your payment type</strong>
            </p>
            <ul className="payment--options">
              {!this.props.cashOnly && accountPaymentsEnabled && (
                <li
                  className={
                    'pay-on-account-option ' +
                    (this.state.payment_method === 'ACCOUNT'
                      ? 'payment-selected'
                      : '') +
                    (this.props.signed_in === false ? ' hidden' : '')
                  }
                  onClick={() => {
                    this.handlePaymentMethodChange('ACCOUNT');
                  }}>
                  Account
                </li>
              )}

              {!orderApprovalsEnabled && (
                <>
                  {itsEnabled && (
                    <li
                      className={
                        'pay-on-card-option ' +
                        (this.state.payment_method === 'CARD'
                          ? 'payment-selected'
                          : '')
                      }
                      onClick={() => {
                        this.handlePaymentMethodChange('CARD');
                      }}>
                      <img
                        src={this.props.assets.cards.card}
                        className="card-payment"
                      />
                      <span>Credit / Debit Card</span>
                    </li>
                  )}

                  {paypalEnabled && (
                    <li
                      className={
                        'pay-by-paypal-option ' +
                        (this.state.payment_method === 'PAYPAL'
                          ? 'payment-selected'
                          : '')
                      }
                      onClick={() => {
                        this.handlePaymentMethodChange('PAYPAL');
                      }}>
                      <img
                        src={this.props.assets.cards.paypal}
                        className="paypal-payment"
                      />
                    </li>
                  )}
                </>
              )}
            </ul>

            {showOrderApprovalMessage}
          </div>
        </div>

        {paymentPanel}
      </div>
    );
  }
}

export default Payment;
